import { useEffect } from "react";
import { useForm, SubmitHandler } from 'react-hook-form';
// Redux Info
import { useAppSelector, useAppDispatch } from '../redux/hooks';
import {selectApi } from '../redux/reducers/MainReducer';
import {setUpFailedCreateNewBudget2sqlVersionModal,
        setUpCreateNewBudget2sqlVersionAdded,
        createNewBudget2sqlVersionAsync,
        selectCreateNewBudget2sqlVersionAdded,
        selectCreateNewBudget2sqlVersionModal,
        budgetVersionAsync} from '../redux/reducers/Budget2SqlReducer';
import { InfoModal } from "./shared/InfoModal";

interface IFormInput {
    name: string;
}

interface IBudgetCreateVersionProps {
    productId: string
}

const BudgetCreateVersion = (props:IBudgetCreateVersionProps) => {

    const {  register,
        handleSubmit} = useForm<IFormInput>({ 
        mode: "onChange"
    });
    
    // Redux Selector
    const api = useAppSelector(selectApi);  
    const modalState = useAppSelector(selectCreateNewBudget2sqlVersionModal);
    const isVersionAdded= useAppSelector(selectCreateNewBudget2sqlVersionAdded);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if(isVersionAdded){
            const id = props.productId
            dispatch(budgetVersionAsync({api, id}))
        } 
    }, [isVersionAdded]);

    const onSubmit: SubmitHandler<IFormInput> = (data:any) => {
        const versionName = data.name
        const productId = props.productId
        dispatch(createNewBudget2sqlVersionAsync({api, versionName, productId}))
    };

    return (
        <div>
            <InfoModal
                header={modalState.header}
                message={modalState.message}
                open={modalState.open}
                success={modalState.success}
                onOK={() => {
                    dispatch(setUpFailedCreateNewBudget2sqlVersionModal())
                }}
            />
            <button 
                hidden = {!isVersionAdded}
                className ="btn btn-sm btn-primary"
                onClick = {()=> dispatch(setUpCreateNewBudget2sqlVersionAdded(false))}>Add New Version</button>
            <form onSubmit={handleSubmit(onSubmit)}> 
                <br />
                <div className="row">
                    <div className="form-group col-6">
                        <input type="text"
                            className="form-control" 
                            id="name" 
                            hidden={isVersionAdded}
                            placeholder="Enter the Version name"
                            {...register("name", { required: true})} 
                        />
                    </div>
                    <div className="form-group col-2 mr-1">
                        <button 
                            type="submit" 
                            hidden={isVersionAdded}
                            className="btn btn-md btn-primary text-uppercase" 
                        >Add</button>
                    </div>
                    <div className="form-group col-2">
                        <button 
                            className="btn btn-secondary btn-md text-uppercase"
                            hidden={isVersionAdded}
                            onClick={()=> dispatch(setUpCreateNewBudget2sqlVersionAdded(true))} 
                        >Cancel</button>
                    </div>
                </div> 
            </form>
        </div>
    )
}

export default BudgetCreateVersion;